// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeroesComponent's private CSS styles */
body, input[text], button {
  color: #888;
  background-color:white;
  font-family: Cambria, Georgia;
}

/* h1 {
  margin-top:10px;
  margin-bottom: 10px;
}
#filter_input {
   border-radius: 4px;
   border: 1px solid;
} */

/* .table {
  all: initial;
} */

/* table {
  table-layout: fixed;
}
td, span {
  
  word-wrap: break-word;
  word-break: break-all;
} */

.table th{
  font-weight:900;
  cursor: pointer;
  /* white-space: nowrap; */
  text-align: left;

}
.table td,.table span{
  /* word-wrap: break-word; */
  
  /* word-wrap: break-word; */
}

.detail td {
  background-color: white;
}

.selected {
  background-color: #CFD8DC !important;
  color: white;
}
.heroes {
  margin: 0 0 2em 0;
  list-style-type: none;
  padding: 0;
  width: 15em;
}
.heroes li {
  cursor: pointer;
  position: relative;
  left: 0;
  background-color: #EEE;
  margin: .5em;
  padding: .3em 0;
  height: 1.6em;
  border-radius: 4px;
}
.heroes li.selected:hover {
  background-color: #BBD8DC !important;
  color: white;
}
.heroes li:hover {
  color: #607D8B;
  background-color: #DDD;
  left: .1em;
}
.heroes .text {
  position: relative;
  top: -3px;
}
.heroes .badge {
  display: inline-block;
  font-size: small;
  color: white;
  padding: 0.8em 0.7em 0 0.7em;
  background-color: #607D8B;
  line-height: 1em;
  position: relative;
  left: -1px;
  top: -4px;
  height: 1.8em;
  margin-right: .8em;
  border-radius: 4px 0 0 4px;
}
.iconButton{
  float:right; 
  color:#444444; 
  width:30px;
  height:30px;
}
.smallIcon{
  width: 21px;
  height: 21px;
  font-size: 21px;
}
#candidateRow:hover {
  /* background-color: #ddeaef; */
}

#candidateRow td {
  color: black;
}

.menu button{
  background: none;
  border: none;
  color:#3170A7;
}

.open_pdf {
  background-color: #262626;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border: none;
}


.shadow-box {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  margin-top: 10px;
}

#filter_input:focus {
  outline: none !important;
  border-color:rgba(0, 0, 0, 0.24);
  box-shadow: 0 0 10px #deedfa;
}




.shadow-box-2 {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  margin-top: 10px;
  display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;
}


:host ::ng-deep .mat-form-field {
  font-family: garamond !important;
  color: black;
  font-weight: 400;
}

:host ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px;
}

:host ::ng-deep .mat-form-field-flex{
  padding: 0px !important;
}

:host ::ng-deep .mat-select-value{
  text-align:center
}


:host ::ng-deep .mat-form-field-underline {
  display: none;
}

tr:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 10px;
}

tr th:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 10px;
}

tr.detail:hover {
  cursor: default;
}

tr.detail td {
  cursor: default;
}

.shadow-box {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  margin-top: 10px;
}

#filter_input:focus {
  outline: none !important;
  border-color:rgba(0, 0, 0, 0.24);
  box-shadow: 0 0 10px #deedfa;
}

.pointer.active.desc:after {
  content: " ▼";
  color: #390263;
}
.pointer.active.asc:after {
  content: " ▲";
  color: #02661d
  
}


.shadow-box-2 {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  margin-top: 10px;
  display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;
}

:host ::ng-deep .mat-form-field {
  font-family: garamond !important;
  color: black;
  font-weight: 400;
}

:host ::ng-deep .mat-form-field-wrapper {
padding-bottom: 0px;
}

:host ::ng-deep .mat-form-field-flex{
padding: 0px !important;
}

:host ::ng-deep .mat-select-value{
text-align:center
}


:host ::ng-deep .mat-form-field-underline {
display: none;
}

.no-style tr {
  background-color: transparent;
}
.no-style {
border: none;
}

.no-style th,
.no-style td {
  border: none;
  padding: 0px;
  padding-right: 8px;
  margin: 0px
}

.no-style thead th,
.no-style thead td {
  border-bottom-width: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/active-candidates/active-candidates.component.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;;;;;GAOG;;AAEH;;GAEG;;AAEH;;;;;;;GAOG;;AAEH;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;;AAElB;AACA;EACE,2BAA2B;;EAE3B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;AACd;;;AAGA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;;;;AAKA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,CAAC,qBAAqB,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB;AACrI;;;AAGA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb;;AAEF;;;AAGA;EACE,wFAAwF;EACxF,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,CAAC,qBAAqB,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB;AACrI;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA;AACA;;;AAGA;AACA,aAAa;AACb;;AAEA;EACE,6BAA6B;AAC/B;AACA;AACA,YAAY;AACZ;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* HeroesComponent's private CSS styles */\nbody, input[text], button {\n  color: #888;\n  background-color:white;\n  font-family: Cambria, Georgia;\n}\n\n/* h1 {\n  margin-top:10px;\n  margin-bottom: 10px;\n}\n#filter_input {\n   border-radius: 4px;\n   border: 1px solid;\n} */\n\n/* .table {\n  all: initial;\n} */\n\n/* table {\n  table-layout: fixed;\n}\ntd, span {\n  \n  word-wrap: break-word;\n  word-break: break-all;\n} */\n\n.table th{\n  font-weight:900;\n  cursor: pointer;\n  /* white-space: nowrap; */\n  text-align: left;\n\n}\n.table td,.table span{\n  /* word-wrap: break-word; */\n  \n  /* word-wrap: break-word; */\n}\n\n.detail td {\n  background-color: white;\n}\n\n.selected {\n  background-color: #CFD8DC !important;\n  color: white;\n}\n.heroes {\n  margin: 0 0 2em 0;\n  list-style-type: none;\n  padding: 0;\n  width: 15em;\n}\n.heroes li {\n  cursor: pointer;\n  position: relative;\n  left: 0;\n  background-color: #EEE;\n  margin: .5em;\n  padding: .3em 0;\n  height: 1.6em;\n  border-radius: 4px;\n}\n.heroes li.selected:hover {\n  background-color: #BBD8DC !important;\n  color: white;\n}\n.heroes li:hover {\n  color: #607D8B;\n  background-color: #DDD;\n  left: .1em;\n}\n.heroes .text {\n  position: relative;\n  top: -3px;\n}\n.heroes .badge {\n  display: inline-block;\n  font-size: small;\n  color: white;\n  padding: 0.8em 0.7em 0 0.7em;\n  background-color: #607D8B;\n  line-height: 1em;\n  position: relative;\n  left: -1px;\n  top: -4px;\n  height: 1.8em;\n  margin-right: .8em;\n  border-radius: 4px 0 0 4px;\n}\n.iconButton{\n  float:right; \n  color:#444444; \n  width:30px;\n  height:30px;\n}\n.smallIcon{\n  width: 21px;\n  height: 21px;\n  font-size: 21px;\n}\n#candidateRow:hover {\n  /* background-color: #ddeaef; */\n}\n\n#candidateRow td {\n  color: black;\n}\n\n.menu button{\n  background: none;\n  border: none;\n  color:#3170A7;\n}\n\n.open_pdf {\n  background-color: #262626;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border: none;\n}\n\n\n.shadow-box {\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n#filter_input:focus {\n  outline: none !important;\n  border-color:rgba(0, 0, 0, 0.24);\n  box-shadow: 0 0 10px #deedfa;\n}\n\n\n\n\n.shadow-box-2 {\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  margin-top: 10px;\n  display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;\n}\n\n\n:host ::ng-deep .mat-form-field {\n  font-family: garamond !important;\n  color: black;\n  font-weight: 400;\n}\n\n:host ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0px;\n}\n\n:host ::ng-deep .mat-form-field-flex{\n  padding: 0px !important;\n}\n\n:host ::ng-deep .mat-select-value{\n  text-align:center\n}\n\n\n:host ::ng-deep .mat-form-field-underline {\n  display: none;\n}\n\ntr:hover {\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-radius: 10px;\n}\n\ntr th:hover {\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-radius: 10px;\n}\n\ntr.detail:hover {\n  cursor: default;\n}\n\ntr.detail td {\n  cursor: default;\n}\n\n.shadow-box {\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n#filter_input:focus {\n  outline: none !important;\n  border-color:rgba(0, 0, 0, 0.24);\n  box-shadow: 0 0 10px #deedfa;\n}\n\n.pointer.active.desc:after {\n  content: \" ▼\";\n  color: #390263;\n}\n.pointer.active.asc:after {\n  content: \" ▲\";\n  color: #02661d\n  \n}\n\n\n.shadow-box-2 {\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  margin-top: 10px;\n  display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;\n}\n\n:host ::ng-deep .mat-form-field {\n  font-family: garamond !important;\n  color: black;\n  font-weight: 400;\n}\n\n:host ::ng-deep .mat-form-field-wrapper {\npadding-bottom: 0px;\n}\n\n:host ::ng-deep .mat-form-field-flex{\npadding: 0px !important;\n}\n\n:host ::ng-deep .mat-select-value{\ntext-align:center\n}\n\n\n:host ::ng-deep .mat-form-field-underline {\ndisplay: none;\n}\n\n.no-style tr {\n  background-color: transparent;\n}\n.no-style {\nborder: none;\n}\n\n.no-style th,\n.no-style td {\n  border: none;\n  padding: 0px;\n  padding-right: 8px;\n  margin: 0px\n}\n\n.no-style thead th,\n.no-style thead td {\n  border-bottom-width: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
